import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/compilation-irrigation-equipment-demand`;
const endpoints = {
    hqListing: () => `${RESOURCE_ENDPOINT}/hq-listing`,
    regionListing: () => `${RESOURCE_ENDPOINT}/region-listing`,
    compilationDistrict: () => `${RESOURCE_ENDPOINT}/district-listing`,
    compilationUpazila: () => `${RESOURCE_ENDPOINT}/upazila-listing`,
    compilationUnion: () => `${RESOURCE_ENDPOINT}/union-listing`,
    getSummeryInfo: () => `${RESOURCE_ENDPOINT}/summary-info`,
    getSummeryListing: () => `${RESOURCE_ENDPOINT}/summary-listing`,
    lock: () => `${RESOURCE_ENDPOINT}/lock`,
};

export default class CompilationIrrigationEquipmentDemandApi {
    public hqListing = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.hqListing();
        return HttpService.get(url, params, headers);
    };

    public regionListing = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.regionListing();
        return HttpService.get(url, params, headers);
    };

    public compilationDistrict = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.compilationDistrict();
        return HttpService.get(url, params, headers);
    };

    public compilationUpazila = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.compilationUpazila();
        return HttpService.get(url, params, headers);
    };

    public compilationUnion = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.compilationUnion();
        return HttpService.get(url, params, headers);
    };

    public getSummeryInfo = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSummeryInfo();
        return HttpService.post(url, payload, params, headers);
    };

    public getSummeryListing = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSummeryListing();
        return HttpService.post(url, payload, params, headers);
    };

    public lock = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.lock();
        return HttpService.post(url, payload, params, headers);
    };
}
